export default "__VITE_ASSET__29537cd9__"